import { render } from "./eventTrackingGA4.vue?vue&type=template&id=2b9f3295"
import script from "./eventTrackingGA4.vue?vue&type=script&lang=js"
export * from "./eventTrackingGA4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__